module.exports = __webpack_public_path__ + "6ab13f18121cb932c94d18bba625a39e.png";